import {Box, Flex, HStack, Text} from '@chakra-ui/react';
import {MetroLogo} from 'components/metro/components/MetroLogo';
import NavRestShopDelivery from 'components/mobile/NavRestShopDelivery';
import {Logo} from 'components/shared';
import {RightBlock} from 'components/shared/right-block-header';
import React, {FC} from 'react';
import {IRestaurantResponse, ProviderTypeEnum} from 'types';

import {Cart} from '../cart';
import {Search} from '../search';
import {SelectAddress} from '../select-address';

interface IProps {
  isDesktop: boolean;
  shouldHideSearch: boolean;
  providerType?: ProviderTypeEnum;
  providerName?: string;
  isMetro?: boolean;
  provider?: IRestaurantResponse;
}

export const HeaderDesktop: FC<IProps> = ({
  isDesktop,
  shouldHideSearch,
  providerType,
  providerName,
  isMetro,
  provider,
}) => {
  return (
    <>
      <Logo isDesktop={isDesktop} />
      {isMetro && (
        <>
          <Text px="10px">x</Text>
          <MetroLogo isDesktop={isDesktop} />
        </>
      )}

      <HStack sx={isMetro ? {w: 'full', mr: '40px'} : {}}>
        <Box maxW="360px" m="0 20px">
          <SelectAddress />
        </Box>
        {!shouldHideSearch && (
          <Box w="full">
            <Search providerType={providerType} providerName={providerName} isMetro={isMetro} provider={provider} />
          </Box>
        )}
      </HStack>

      <Flex flex={1} justifyContent="flex-end">
        {!isMetro && (
          <Flex justifyContent="center" flex={1}>
            <HStack spacing="10px">
              <NavRestShopDelivery />
            </HStack>
          </Flex>
        )}

        <RightBlock isDesktop={isDesktop}>
          {!isMetro && (
            <Box mr="5px">
              <Cart />
            </Box>
          )}
        </RightBlock>
      </Flex>
    </>
  );
};
